//AzeemKhan : 06-11-2023 : BT-108797 -  Breeze - Live pulse expanded view ---Start

import React, { forwardRef, memo, useState } from "react";
import { Col, Dropdown, Row } from "react-bootstrap";
import BzInputText from "./BzInputText";
const FilterDropdownToggle = forwardRef(({ children }, ref) => (
    <div
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            // onClick(e);
        }}
    >
        {children}
    </div>
));

const CustomMenu = React.forwardRef(
    ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
        const [strSearchValue, setStrSearchValue] = useState('');
        const handleInputChange = (e) => {

            setStrSearchValue(e.target.value?.toUpperCase());
        };

        return (
            <div ref={ref} style={style} className={className} aria-labelledby={labeledBy}>
                <Row className='g-0 p-2'>
                    <Col>
                        <div className='ag-react-container'>
                            <div className='d-flex flex-row justify-content-start align-items-center'>
                                <div className='icon-14 icon-search icon-grey m-t-3'></div>
                                <BzInputText size="sm" autoFocus className='p-l-30 scripname-searchtext' value={strSearchValue} placeholder='Search scrip' onChange={handleInputChange} />
                            </div>
                        </div>
                    </Col>
                </Row>
                <div className='dropdown-content'>
                    <ul className='list-unstyled'>
                        {React.Children?.toArray(children)?.filter(
                            (child) =>
                                !strSearchValue || child?.props?.children?.toUpperCase()?.includes(strSearchValue?.toUpperCase())
                        )}
                    </ul>
                </div>
            </div>
        );
    },
);

const BzSearchableDropdown = ({ className, strToggelValue, ...props }) => {
    return (
        <Dropdown as={FilterDropdownToggle} className={className} {...props}>
            <Dropdown.Toggle className='btn-default'>
                {strToggelValue}
            </Dropdown.Toggle>
            <Dropdown.Menu as={CustomMenu} >
                {props?.children}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default memo(BzSearchableDropdown);
//AzeemKhan : 06-11-2023 : BT-108797 -  Breeze - Live pulse expanded view ---End
